import { render } from "./maskLayer.vue?vue&type=template&id=b4a1174c&lang=pug"
import script from "./maskLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./maskLayer.vue?vue&type=script&setup=true&lang=js"

import "./maskLayer.vue?vue&type=style&index=0&id=b4a1174c&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__